import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext, type ReactNode } from "react";
export type NavToolbarSlots = {
  actions: ReactNode;
  leading: ReactNode;
  panels: ReactNode;
};

/**
 * The focused screen's published slots, or `null` while no screen publishes any. Always provided
 * by `NavToolbarProvider` (Learn): reading it anywhere else is a bug, so a missing provider throws
 * instead of looking like "nothing published".
 */
export const NavToolbarSlotsContext = createContext(
  defaultError<NavToolbarSlots | null>("NavToolbarSlotsContext"),
);
/**
 * The publish function, or `null` outside a `NavToolbarProvider`: publishers (the morpheme panels
 * toolbar, the Learn deck) also mount where no toolbar host exists, and publish nothing there.
 */
export const NavToolbarPublisherContext = createContext<
  ((slots: NavToolbarSlots) => () => void) | null
>(null);
